import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar";
import SidebarPersonalInfo from "../SidebarPersonalInfo";

import bg from "../../assects/images/bg.jpg";
import bgtwo from "../../assects/images/bgtwo.jpg";
import gredeintbg from "../../assects/images/gredeintbg.jpg";

const Main = () => {
  return (
    <div className="lg:pt-[220px] relative">
      <div className=" absolute top-0 left-0  -z-10">
        <img
          className="h-screen w-screen fixed -z-10"
          // src={gredeintbg}
          src={bg}
          alt=""
        />
      </div>
      <div className="lg:container mx-auto grid grid-cols-12 md:gap-10">
        <SidebarPersonalInfo />
        <div className=" col-span-12 lg:col-span-8 mb-8 lg:mx-5">
          <Navbar />
          <div className=" mt-40 mx-5 lg:m-0">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
